/* Copyright (c) 2023 Black Sun Plc. All rights reserved. */
/*jslint browser: true, fudge: true, long: true */
/*global blacksunplc, dataLayer, decodeURIComponent, dialogPolyfill, document, encodeURIComponent, self */

(function (globalThis) {
    "use strict";

    var arrays = blacksunplc.arrays;           // import * as arrays  from "module:blacksunplc/arrays"
    var attributes = blacksunplc.attributes;   // import * as arrays  from "module:blacksunplc/attributes"
    var dates = blacksunplc.dates;             // import * as dates   from "module:blacksunplc/dates"
    var events = blacksunplc.events;           // import * as events  from "module:blacksunplc/events"
    var storage = blacksunplc.storage;         // import * as storage from "module:blacksunplc/storage"

    /*
     * All timestamps are integers in the closed interval 0 to 8640 trillion.
     * The `modified` timestamp is zero when the cookie has not been stored.
     */
    var COOKIE_NAME = "CookieControl";

    /* Maximum age is a period of 90 days, expressed in seconds. */
    var COOKIE_OPTIONS = {maxAge: 90 * 24 * 60 * 60};

    /* The known Google Analytics cookies (last checked on 2020-04-01). */
    var GANALYTICS_NAMES = [/^_ga/, "_gid"];

    /* dataLayer variable that tracks user's consent.
     * MUST match the name used in the GTM exception rules to prevent GTM tags from firing.
     */
    var COOKIE_CONSENT_LIST = "cookieConsentList";

    /* dataLayer event that fires when the user accepts the use of cookies. */
    var CONSENT_GRANTED_EVENT = "cookieConsentGranted";

    /* dataLayer event that fires when the user revokes consent to the use of cookies. */
    var CONSENT_REVOKED_EVENT = "cookieConsentRevoked";

    /* dataLayer variable that tracks the date/time when consent was granted or revoked. */
    var COOKIE_CONTROL_DATE = "cookieControlDate";

    /* Initialise the dataLayer before GTM loads. */

    /* The name of the data layer. */
    var dataLayerName = "dataLayer";

    /* Initialise the data layer. */
    globalThis[dataLayerName] = globalThis[dataLayerName] || [];

    /* Implements the Web Storage API for cookies. */
    var cookieStorage = storage.cookieStorage();

    /** @return {!blacksunplc.CookieControl} */
    function getCookieControl() {
        var cookieItem = cookieStorage.getItem(COOKIE_NAME);
        if (cookieItem) {
            return /** @type {!blacksunplc.CookieControl} */ (JSON.parse(decodeURIComponent(cookieItem.value)));
        }
        return {modified: 0, consent: {}};
    }

    /** @param {!blacksunplc.CookieControl} cookieControl */
    function setCookieControl(cookieControl) {
        cookieControl.modified = dates.now();
        var value = encodeURIComponent(JSON.stringify(cookieControl));
        cookieStorage.setItem(COOKIE_NAME, value, COOKIE_OPTIONS);
    }

    /** @param {!Object} data */
    function dataLayerPush(data) {
        globalThis[dataLayerName].push(data);
    }

    function enableGtmJsScripts() {
        var scripts = document.querySelectorAll("script[data-gtmjs-src]");
        dataLayerPush({
            "gtm.start": dates.now(),
            "event": "gtm.js"
        });
        scripts.forEach(function(scriptTag) {
            var gtmjsSrc = scriptTag.getAttribute("data-gtmjs-src");
            scriptTag.src = gtmjsSrc;
        });
    }

    storage.installFilter();
    storage.certifyLawfulBasis([COOKIE_NAME, 'preloaderSeen']);

    if (getCookieControl().consent.ganalytics) {
        storage.certifyLawfulBasis(GANALYTICS_NAMES);

        var cookieConsentListUpdatedEvent  = {};
        cookieConsentListUpdatedEvent[COOKIE_CONSENT_LIST] = GANALYTICS_NAMES;
        dataLayerPush(cookieConsentListUpdatedEvent);

        enableGtmJsScripts();

        events.ready(function () {
            var gaCheckbox = /** @type {!HTMLInputElement} */ (document.querySelector("#give-consent-ganalytics"));
            gaCheckbox.checked = true;
        });
    } else {
        var cookieConsentListUpdatedEvent  = {};
        cookieConsentListUpdatedEvent[COOKIE_CONSENT_LIST] = [];
        dataLayerPush(cookieConsentListUpdatedEvent);
    }

    /* Register the "dialog" tagName in old browsers so CSS is applied. */
    if (!globalThis.HTMLDialogElement) {
        document.createElement("dialog");
    }

    function showCookieDialog() {
        function isWebCrawler() {
            var BOT_USER_AGENTS = [
                "ahrefsbot",
                "archiveteam.org",
                "baiduspider",
                "bingbot",
                "bingpreview",
                "facebookexternalhit",
                "googlebot",
                "insights",
                "jobo",
                "lighthouse",
                "linkedinbot",
                "mediapartners-google",
                "nutch",
                "proximic",
                "sogou web spider",
                "terroroftinytown",
                "yahoo! slurp"
            ];

            var userAgent = (window.navigator.userAgent || "").toLowerCase();
            for (var i = 0; i < BOT_USER_AGENTS.length; ++i) {
                var botUserAgent = BOT_USER_AGENTS[i];
                if (userAgent.indexOf(botUserAgent) !== -1) {
                    console.log("Detected bot: ", botUserAgent);
                    return true;
                }
            }
            return false;
        }

        function hasCookieControl() {
            return !!cookieStorage.getItem(COOKIE_NAME);
        }

        return !(isWebCrawler() || hasCookieControl());
    }

    /* Initialisation of `dialogPolyfill` may fail in old browsers. */
    if (!globalThis.dialogPolyfill) {
        /* No reason to make AJAX call. */
        return;
    }

    /* Wait for DOMContentLoaded before accessing the DOM. */
    events.ready(function () {
        var dialog = /** @type {?HTMLDialogElement} */ (document.querySelector(".cookiecontrol"));
        if (!dialog) {
            return;
        }

        dialogPolyfill.registerDialog(dialog);

        function showModal() {
            dialog.showModal();
        }

        /**
         * @param {!Event} event
         */
         function toggleCookieBody(event) {
            var cookieBody = dialog.querySelector(".cookiecontrol-body");
            var cookieFooter = dialog.querySelector(".cookiecontrol-footer");

            $(cookieBody).slideDown();
            $(cookieFooter).slideUp();

            event.preventDefault();
        }

        /**
         * @param {!Event} event
         */
         function acceptAllCookies(event) {
            var checkboxes = dialog.querySelectorAll("input[type='checkbox']");

            arrays.forEach(checkboxes, function (/** !HTMLInputElement */ checkbox) {
                checkbox.checked = true;
            });

            $(".cookiecontrol .btn-save").trigger("click");
            event.preventDefault();
        }

        /**
         * @param {!Event} event
         */
        function saveAndClose(event) {
            var gaCheckbox = /** @type {!HTMLInputElement} */ (document.querySelector("#give-consent-ganalytics"));
            var cookieControl = getCookieControl();

            if (gaCheckbox.checked) {
                storage.certifyLawfulBasis(GANALYTICS_NAMES);
                cookieControl.consent.ganalytics = dates.now();

                enableGtmJsScripts();

                var consentGrantedEvent = {"event": CONSENT_GRANTED_EVENT};
                consentGrantedEvent[COOKIE_CONTROL_DATE] = cookieControl.modified;
                dataLayerPush(consentGrantedEvent);

                var cookieConsentListUpdatedEvent  = {};
                cookieConsentListUpdatedEvent[COOKIE_CONSENT_LIST] = GANALYTICS_NAMES;
                dataLayerPush(cookieConsentListUpdatedEvent);

                if (typeof ga !== "undefined" && ga) {
                    ga("send", "pageview");  // Fire pageview to collect current page view.
                }
            } else {
                storage.revokeLawfulBasis(GANALYTICS_NAMES);
                delete cookieControl.consent.ganalytics;

                var consentRevokedEvent = {"event": CONSENT_REVOKED_EVENT};
                consentRevokedEvent[COOKIE_CONTROL_DATE] = cookieControl.modified;
                dataLayerPush(consentRevokedEvent);

                var cookieConsentListUpdatedEvent  = {};
                cookieConsentListUpdatedEvent[COOKIE_CONSENT_LIST] = [];
                dataLayerPush(cookieConsentListUpdatedEvent);
            }

            setCookieControl(cookieControl);

            dialog.close();
            event.preventDefault();
        }

        function isCookiePolicyPage() {
            return attributes.classList(document.body).contains("cookie-policy");
        }

        arrays.forEach(document.querySelectorAll(".cookiecontrolbutton button"), function (button) {
            events.add(button, "click", showModal);
        });

        arrays.forEach(dialog.querySelectorAll(".btn-toggle-body"), function (button) {
            events.add(button, "click", toggleCookieBody);
        });

        arrays.forEach(dialog.querySelectorAll(".btn-accept-all"), function (button) {
            events.add(button, "click", acceptAllCookies);
        });

        arrays.forEach(dialog.querySelectorAll(".btn-save"), function (button) {
            events.add(button, "click", saveAndClose);
        });

        if (showCookieDialog() && !isCookiePolicyPage()) {
            showModal();
        }
    });
}(self));
